export default "__VITE_ASSET__CmUqG3I___"